import React, { useState } from "react";
import { FormGroup } from "react-bootstrap";
import { Field } from "react-final-form";
import { Error } from "../Conditionals/Error";
import { BackendURL } from "../../../Constants/AppData";

import { HoverRowColor } from "../../../Constants/ColorChart";
import styled from "styled-components";

const StyledFieldWrapper = styled.div`
    &.attachments {
        ul {
            list-style: none;
            display: flex;
            margin-bottom: 36px;
            padding: 0;
            flex-direction: column;
            max-height: 135px;
            overflow-y: auto;
            overflow-x: hidden;
        }
        
        li {
            display: flex;
            align-items: flex-start;
            flex-grow: 1;
            width: 33%;
            &:hover{
                background: ${ HoverRowColor };
            }
        }
        
        a:not(.link) {
            display: flex;
            flex-grow: 1;
            text-decoration: none;
            padding: 10px;
            &:hover {
                text-decoration: underline;
            }
        }
        & .deleteAttachment {
            padding: 10px;
            margin: 0;
            display: inline-block;
            opacity: 0.5;
            background: transparent;
            border: 0px solid transparent;
            span {
                display: inline-block;
                background: #dc3545;
                color: white;
                border-radius: 30px;
                height: 20px;
                width: 19px;
                line-height: 20px;
                font-weight: bold;
                font-size: 18px;
            }
            &:hover{
                opacity: 1
            }
        }
    }
`

export const FileField = ( props ) => {
    const [ fileList, setFileList ] = useState( [] )

    const { children, ...otherProps } = props
    const { fileFieldId, fileFieldLabel, fileFieldName, hint, validator } = otherProps

    return <Field name={ fileFieldName } validate={ validator }>
        { ( { input: { value, onChange, ...input }, meta } ) => {
            const fileOnChange = async ( event, value ) => {
                event.preventDefault();

                let myHeaders = new Headers();
                myHeaders.append( "Accept", "application/vnd.api+json" );
                myHeaders.append( "Authorization", "Bearer " + window.localStorage.getItem( "token" ) );
                myHeaders.append( "Content-Disposition", "file; filename=\"" + [ ...value ][0].name + "\"" );
                myHeaders.append( "Content-Type", "application/octet-stream" );
                myHeaders.append( "Host", BackendURL );

                const requestOptions = {
                    method: "POST",
                    headers: myHeaders,
                    body: value[0],
                }

                let urlToSend = BackendURL + "/jsonapi/ticket/ticket/field_ticket_attachments";
                const response = await fetch( urlToSend, requestOptions )
                    .catch((error)=> {
                        console.error("Error on fetch in FileField", error);
                    });

                const result = await response.json()
                    .catch((error)=> {
                    console.error("Error on response.json()", error);
                });

                const fileToParse = {
                    type: "file--file",
                    id: result.data.id,
                    meta: { display: true, description: "" },
                    name: result.data.attributes.filename
                }

                const newFileList = [ ...fileList, fileToParse ];

                setFileList( newFileList );

                return newFileList;

                // Documentation is lacking on Drupal's JSON:API for uploads, use this
                // https://www.drupal.org/node/3024331
                // in short: use the endpoint, get a UUID and create a relationship with the data being stored.

            }

            const removeFromAttachmentFromTicket = ( idToRemove, name ) => {
                const newFileList = fileList.filter( ( item ) => item.id !== idToRemove );

                setFileList( newFileList );

                return newFileList;

            }

            const getFileDownloadToken = ( id ) => {
                // TODO: avoid duplicated code and store this in a separate file accessible to both components.
                return new Promise( ( resolve, reject ) => {
                    const controller = new AbortController();
                    const timeoutId = setTimeout( () => controller.abort(), 10000 );
                    const token = localStorage.getItem( "token" );

                    fetch( BackendURL + "/file/" + id + "/get-download-token", {
                        signal: controller.signal,
                        headers: {
                            'content-type': 'text/plain',
                            'Authorization': 'Bearer ' + token
                        },
                        authorization: 'Bearer ' + token,
                        method: 'POST',
                        body: ""
                    } )
                        .then( result => {
                            if ( !result.ok ) {
                                return reject( result )
                            }
                            return result.json()
                        } )
                        .then( response => {
                            if ( response.status === 403 || response.status === 401 ) {
                                localStorage.clear();
                                window.location.href = "/";
                            }
                            // console.info( response );
                            resolve( response );
                            clearTimeout( timeoutId );
                        } )
                        .catch( error => {
                            if ( error.name === "AbortError" ) {
                                console.error( "Timeout" );
                                reject( "AbortError" );
                            } else {
                                console.error( "Error fetching the file token." )
                            }
                        } )
                } )
            }

            const handleDownload = ( id, filename ) => {
                getFileDownloadToken( id )
                    .then( response => {
                        let link = document.createElement( 'a' );
                        link.download = filename;
                        link.href = BackendURL + "/file/" + response.media_uuid + '/download/' + response.token;
                        link.click();
                        //console.info( "Link:", link );
                        link.remove();
                    } )
                    .catch( error => console.error( error ) );
            }

            return <FormGroup
                className={ (meta.error && (input.value === undefined || input.value === "") ? "has-error " : " ") + (!meta.error && (meta.modified || meta.touched) ? "is-success " : " ") }>
                <StyledFieldWrapper className="file attachments">
                    <label htmlFor={ fileFieldId }>{ fileFieldLabel }
                        { meta.error && (input.value === undefined || input.value === "") &&
                        <Error name={ fileFieldName }>{ meta.error }</Error> }
                    </label>
                    { hint && <p>
                        { hint }
                    </p> }
                    { children && <>{ children }</> }
                    <ul id="fileList">
                        { fileList.map( ( file ) => {
                            return <li key={ file.id } className={ "file" }>
                                <a
                                    href={ "/#" }
                                    onClick={ event => {
                                        event.preventDefault();
                                        handleDownload( file.id, file.name );
                                    } }
                                    target="_blank"
                                    download={ file.name }
                                    rel="noopener noreferrer"
                                >
                                    { file.name }
                                </a>
                                <button
                                    className={ "deleteAttachment" }
                                    onClick={ ( event ) => {
                                        event.preventDefault()
                                        removeFromAttachmentFromTicket( file.id, fileFieldName );
                                    } }
                                >
                                    <span>×</span>
                                </button>
                            </li>
                        } ) }
                    </ul>
                    <input
                        id={ fileFieldId }
                        type="file"
                        multiple={ false }
                        onChange={ ( event ) => {
                            const { target } = event
                            fileOnChange( event, target.files )
                                .then( () => {
                                    target.value = ""
                                } );
                        } }
                        onBlur={ input.onBlur }
                        onFocus={ input.onFocus }
                        checked={ undefined }
                    /><input
                    id={ "__" + fileFieldId }
                    type="hidden"
                    name={ fileFieldName }
                    onChange={ onChange( fileList ) }
                />
                </StyledFieldWrapper>
            </FormGroup>
        } }

    </Field>
}
